import React from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';

import Location from '@r6digital/rapidstor-types/react/entities/Location';

import Navbar from '../components/Navbar';

import classes from './QuoteSent.module.scss';

import { ReactComponent as IconQuote } from '../assets/icon-quote.svg';

function QuoteSent() {
    const location = useLoaderData() as Location;
    const navigate = useNavigate();

    return (
        <>
            <Navbar label={''} />
            <div className={`${classes.container}`}>
                <div className={`${classes.confirmation}`}>
                    <IconQuote />
                    <h1>Email Sent</h1>
                    <p>Thank you, your email has been sent to your inbox.</p>
                </div>
                <div className={`${classes.buttons}`}>
                    <button onClick={() => navigate(`/`)}>Return Home</button>
                    <button onClick={() => navigate(`/locations/${location.slug}/units`)}>
                        Return To Units
                    </button>
                </div>
            </div>
        </>
    );
}

export default QuoteSent;
